import React, { ButtonHTMLAttributes } from 'react';

import { BasicButton, IconButton } from '@adsk/alloy-react-button';
import { ChevronRightIcon, RenderIconType } from '@adsk/alloy-react-icon';
import { useTheme } from '@adsk/alloy-react-styles';
import { StylableComponent } from '@adsk/alloy-react-theme';

type Props = StylableComponent<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>;

const renderIcon: RenderIconType = (p) => <ChevronRightIcon {...p} />;

const NextArrow = React.forwardRef<HTMLButtonElement, Props>(
  ({ style, className, onClick, ...props }, ref) => {
    const theme = useTheme();
    const modalTokens = theme.tokens?.component?.modal;

    return (
      <IconButton
        {...props}
        size={42}
        ref={ref}
        className={className}
        style={[
          {
            position: 'absolute',
            top: '43%',
            right: '-80px',
            color: modalTokens?.arrow?.['icon-color'],
          },
          style,
        ]}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick && onClick(e);
        }}
        renderIcon={renderIcon}
      />
    );
  },
);

NextArrow.displayName = 'PrevArrow';

NextArrow.propTypes = {
  ...BasicButton.propTypes,
};

export default NextArrow;
